import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import WorkHoursList from "./WorkHoursList";
import WorkHoursImportModal from "../components/WorkHoursImportModal";

const WorkHoursListWrapper = () => {

    // STATES

    const [openFormDrawer, setOpenFormDrawer] = useState<boolean>(false);
    const [workHoursSelected, setWorkHoursSelected] = useState<any | null>(null);
    const [isOpenImportModal, setIsOpenImportModal] = useState<boolean>(false);
    const workHoursTableRefetchRef = useRef<(() => void) | null>(null);

    const registerTableRefetch = useCallback((fn: () => void) => {
        workHoursTableRefetchRef.current = fn;
    }, []);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Control de acceso' },
        { name: 'Horas de trabajo', href: menuRoutes.workHours.path },      
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de registros de horas de trabajo" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                    {
                        userCan('create', 'work_hour') &&
                        (
                            <Button
                                variant="outline"
                                onClick={() => setIsOpenImportModal(true)}
                            >
                                Importar Excel
                            </Button>
                        )
                    }
                    {
                        userCan('create', 'work_hour') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setOpenFormDrawer(true) 
                                    setWorkHoursSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear registro
                            </Button>
                        )
                    }
                    </div>

                </PageHeader>
                <WorkHoursList
                    openFormDrawer={openFormDrawer}
                    setOpenFormDrawer={setOpenFormDrawer}
                    workHoursSelected={workHoursSelected}
                    setWorkHoursSelected={setWorkHoursSelected}
                    registerTableRefetch={registerTableRefetch}
                />
                <WorkHoursImportModal
                    isOpen={isOpenImportModal}
                    onClose={() => setIsOpenImportModal(false)}
                    refetch={() => {
                        workHoursTableRefetchRef.current?.();
                    }}
                />
            </FiltersProvider>
        </Fragment>
    );
}

export default WorkHoursListWrapper;
